export default "__VITE_ASSET__32659f3e__"